import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import PhoneInput from 'react-phone-number-input'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import Alert from '../../../../_metronic/partials/alert'
import { trim } from '../../../../_metronic/helpers'
import { fetchStartWithForward } from '../../../../redux/actions/common'
import { setKycSubStep } from '../redux/actions'
import { MaintenanceModeBanner } from '../../../../_metronic/helpers/components/MaintenanceModeBanner'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'

import { scrollToErros } from '../../../modules/loanApplication/steps/Step1Sub1'

const Step1Sub0: FC<any> = ({ sendOTP, setMobileNo }: any) => {
  const dispatch = useDispatch()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg] = useState<string>('')
  const [alertType] = useState<any>('primary')

  const handleCreateApplication = () => {
    dispatch(setKycSubStep(1))
  }

  const initialValues = {
    mobileNumber: '',
  }

  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .test('mobileValidation', 'Please enter valid Singapore number', (value: any) => {
        if (!value) return false
        // Use libphonenumber-js to validate phone number format
        const number = parsePhoneNumberWithError(value, 'SG')
        // Use libphonenumber-js to validate phone number format
        return isValidPhoneNumber(value, 'SG') && number.isValid() && number.country === 'SG'
      }),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const { mobileNumber } = trim(values)
      setMobileNo(mobileNumber)
      dispatch(fetchStartWithForward())
      sendOTP({
        variables: {
          mobileNo: mobileNumber,
          isApplicantOrShareholder: true,
          isCoApplicantKYB: false,
        },
      })
      setSubmitting(false)
    },
  })

  return (
    <div className='d-flex flex-column flex-column-fluid'>
      <MaintenanceModeBanner />
      <h2>Resume Application</h2>
      <div className='sub-heading text-muted mb-10'>
        Welcome back, you are hardly 2 steps away, please continue the journey and complete the
        application.
      </div>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='row mb-10'>
          <label htmlFor='' className='mt-3 form-label fs-6 fw-bolder text-dark col-sm-3 required'>
            Mobile Number
          </label>
          <div className='col-sm-9'>
            <PhoneInput
              id='mobileNumber'
              international
              defaultCountry='SG'
              // countryCallingCodeEditable={false}
              value={formik.values.mobileNumber}
              onChange={(value: any) => formik.setFieldValue('mobileNumber', value)}
              placeholder='Enter phone number'
              className='int-phone-input'
            />
            {(formik.touched.mobileNumber || formik.values.mobileNumber === undefined) &&
              formik.errors.mobileNumber && (
                <div className='text-danger mt-2'>{formik.errors.mobileNumber}</div>
              )}
          </div>
        </div>

        <div className='d-flex justify-content-between'>
          <button
            type='button'
            className='btn btn-lg btn-primary me-3'
            onClick={() => handleCreateApplication()}
          >
            Create new application
          </button>
          <button
            type='submit'
            className='btn btn-lg btn-primary me-3'
            onClick={() => {
              scrollToErros()
            }}
          >
            Send OTP
          </button>
        </div>
      </form>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export { Step1Sub0 }
